import React, { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function Layout({ children }) {
  const [openPrefs, setOpenPrefs] = useState(false);
  return (
    <div className="min-h-screen bg-[#0B0F14] text-[#F1ECDE] flex flex-col overflow-x-hidden">
      <Header />
      <main id="main" className="flex-1 pt-[68px]">
        {children}
      </main>
      <Footer onOpenCookiePrefs={() => setOpenPrefs(true)} />
      <CookieBanner openPrefs={openPrefs} setOpenPrefs={setOpenPrefs} />
    </div>
  );
}
